import { EnergyOverviewMetrics } from 'pages/app/energy-overview/types.ts'
import { Granularity } from 'types/contracts.ts'
import { PriceHistoryMetrics } from 'store/queries/bolt-api/contracts/types.ts'

// GET YEAR OVERVIEW METRICS

export type GetYearOverviewMetricsPayload = {
  email: string
  billingContractNumber: string
}

export type GetYearOverviewMetricsResponse = {
  yearOverviewMetrics: EnergyOverviewMetrics
}

// GET PRICE HISTORY

export type GetPriceHistoryPayload = {
  granularity: Granularity
  from: string
  until: string
  unit?: 'kWh' | 'MWh'
  type?: PriceHistoryType
}

export type GetPriceHistoryResponse = {
  priceHistory: PriceHistoryMetrics
}

// ENUMS

export enum PriceHistoryType {
  PRICE = 'price',
  PRICE_ELECTRICITY = 'price-electricity',
  PRICE_GAS = 'price-gas'
}
